import { hiddenClass } from "../config.js";

const openClass = 'open';
const closeClass = 'closed';

export const initaliseFooter = () => {
    const expandableNavItems = document.querySelectorAll('.js-footer-mobile .js-expandable-nav-item');
    if (expandableNavItems.length === 0) {
        return;
    }

    expandableNavItems.forEach(item => {
        const expandIcon = item.querySelector('.expand-children');
        const collapseIcon = item.querySelector('.collapse-children');
        const children = item.parentElement.querySelector('.js-expandable-children');
        if (!expandIcon || !collapseIcon || !children) {
            return;
        }

        item.addEventListener('click', () => {
            if (item.classList.contains(closeClass)) {
                item.classList.remove(closeClass);
                item.classList.add(openClass)

                expandIcon.classList.add(hiddenClass);
                collapseIcon.classList.remove(hiddenClass);
                children.classList.remove(hiddenClass);
            } else {
                item.classList.add(closeClass);
                item.classList.remove(openClass)

                expandIcon.classList.remove(hiddenClass);
                collapseIcon.classList.add(hiddenClass);
                children.classList.add(hiddenClass);
            }
        });
    })
}